<template >
<div id="pdf">
  <v-data-table
    :headers="headers"
    :items="getAllItems"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top >
      <v-toolbar flat color="white" >
        <v-toolbar-title>PRODUCTOS Y SERVICIOS</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar producto / servicio..."
        single-line
        hide-details
      ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >NUEVO</v-btn>
            
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.nombre" label="Nombre"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field v-model="editedItem.precio" label="Precio Venta" prefix="Q "></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.ubicacion" label="Ubicacion Inmueble"></v-text-field>
                  </v-col>
              
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.tipo" label="Tipo"></v-text-field>
                  </v-col>             
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      v-model="editedItem.estado"
                      :items="Estados"
                      label="Estado Inmueble"            
                    ></v-select>
                  </v-col>          
                </v-row>
                <!-- <v-row>
                    <v-autocomplete  v-model="editedItem.idpersona" 
                    :items="getCategoriasActivas" outlined  clearable hide-selected item-text="nombre" item-value="idpersona" label="Seleccione Propietario" >
                    </v-autocomplete>
                </v-row> -->
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.tipo`]="{ item }">
      <p v-text="item.tipo"></p>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small  class="mr-2"  @click="editItem(item)" >
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item.idinmueble)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Recargar</v-btn>
    </template>
  </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
     name:'Productos',  
     data: () => ({
      search:'',
      dialog: false,
      itemstipo:["Bien","Servicio"],
      editedIndex: -1,
      Estados: ["Disponible","Reservado","Vendido"],
      editedItem: {
        nombre: '',
        ubicacion:'',
        precio:1,
        tipo:'Bien',
        estado:'Disponible'
      },
      defaultItem: {
        nombre: '',
        ubicacion:'',
        precio:1,
        tipo:'Bien',
        estado:'Disponible'
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Registro' : 'Editar Registro'
      },
      getAllItems(){
        return this.$store.getters.getAllProductos
      },
      getCategoriasActivas(){
        return this.$store.getters.getCategoriasActivas
      },
      getTokenUser(){
        return this.$store.getters.getTokenUser
      },
      headers(){
        return[ 
        { text: 'Nombre', value: 'nombre' },
        { text: 'Ubicacion', value: 'ubicacion' },
        { text: 'Precio', value: 'precio' },
        { text: 'Tipo',align: 'center', value: 'tipo' },
        { text: 'Estado',align: 'center', value: 'estado',sortable: false, },
        { text: 'Opciones',align: 'center', value: 'actions', sortable: false },
      ]
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    async created () {
      await this.initialize()
    },

    methods: {  
      async initialize () {  
        await this.$store.dispatch('setProductos')      
      },
      parsedata(){      
       
        this.editedItem.stockactual=parseInt(this.editedItem.precio)

      },
      editItem (item) {
        this.editedIndex = this.getAllItems.indexOf(item);
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.parsedata() 
        
      },
      deleteItem (idinmueble) {
        
        Swal.fire({
          title: 'Esta Seguro?',
          text: "El registro será Eliminado!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, Desactivar!',
          cancelButtonText: 'Cancelar!'
        }).then((result) => {
          if (result.isConfirmed) {
            //Procedimiento para eliminarlo
            this.cambiarestado("Eliminado",idinmueble)
          }
        })
       
              
      },
      cambiarestado(estado,idinmueble) {
        axios.put(`${this.$store.state.urlapi}/inmuebles/${idinmueble}`,{estado:estado},this.getTokenUser)
          .then(() => {
            this.alertDone();
            this.initialize();
          });
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.parsedata()
        if (this.editedIndex > -1) {       
          this.putItem()
        } else {
          this.postItem()
        }
        this.close()
      },
      postItem(){
        axios.post(`${this.$store.state.urlapi}/inmuebles`,this.editedItem,this.getTokenUser).then(()=>{                
          this.alertDone()
          this.initialize()          
        }).catch(err=> {this.alertError(), console.log(err)})
      },
      putItem(){     
       axios.put(`${this.$store.state.urlapi}/inmuebles/${this.editedItem.idinmueble}`,this.editedItem,this.getTokenUser).then(()=>{         
          this.alertDone()
          this.initialize()          
        })
        
      },
      //Notificaciones Swal
      alertDone(){
        Swal.fire({
          icon: 'success',
          title: 'Realizado',
          showConfirmButton: false,
          timer: 1500
        })
      },
      alertError(){
        Swal.fire({
          icon: 'error',
          title: 'No pudo realizarse la solicitud',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    
}
</script>